import { render, staticRenderFns } from "./FontSelector.vue?vue&type=template&id=7e9885b2&scoped=true&"
import script from "./FontSelector.vue?vue&type=script&lang=js&"
export * from "./FontSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9885b2",
  null
  
)

export default component.exports